import { useRef, useState } from "react";
import { Buffer } from "buffer";

interface SignatureRef {
  getTrimmedCanvas: () => HTMLCanvasElement;
  isEmpty: () => boolean;
  clear: () => void;
}

/**
 * Encapsulates signature pad ref management, validation, and data extraction.
 * Use with ANSignature from @answersnow/pkg-theme.
 */
const useSignature = () => {
  const signatureRef = useRef<SignatureRef | null>(null);
  const [isValidSignature, setIsValidSignature] = useState(false);

  const handleSignatureChange = (value?: string, type?: string) => {
    if (signatureRef.current) {
      if (type === "typed") {
        setIsValidSignature(Boolean(value));
      } else {
        setIsValidSignature(!signatureRef.current.isEmpty());
      }
    }
  };

  const getSignatureData = () => {
    if (!signatureRef.current) return null;
    const dataUrl = signatureRef.current.getTrimmedCanvas().toDataURL();
    const base64 = dataUrl.replace(/^data:image\/\w+;base64,/, "");
    const buffer = Buffer.from(base64, "base64");
    return { dataUrl, buffer };
  };

  const clearSignature = () => {
    signatureRef.current?.clear();
    setIsValidSignature(false);
  };

  return {
    signatureRef,
    isValidSignature,
    handleSignatureChange,
    getSignatureData,
    clearSignature,
  };
};

export default useSignature;
